<template>
    <main>
      <form-dialog
        v-model="isActive"
        max-width="800px"
        :sending="sendingToMagazzino"
        @confirm="onConfirm">

        <v-flex xs12>
            <icon-label color="accent">{{ $t('magazzino.label.dati_prodotto') }}</icon-label>
        </v-flex>

        <v-flex xs12 sm4>
            <text-field :label="$t('prodotti.label.sku')" v-model="form.sku" show-details required/>
        </v-flex>

        <v-flex xs12 sm4>
            <text-field :label="$t('prodotti.label.produttore')" v-model="form.produttore" show-details required/>
        </v-flex>

        <v-flex xs12 sm4>
            <text-field :label="$t('prodotti.label.nome')" v-model="form.name" show-details required/>
        </v-flex>

        <v-flex xs12 sm6>
            <span class="left" style="margin-top: 4px;">{{ $t('prodotti.label.prezzo_acquisto') }}: </span>
            <number-input v-model.number="form.price" :min="0" type="price" suffix="€" hide-buttons class="left"/>
        </v-flex>

        <v-flex xs12 sm6>
            <span class="left" style="margin-top: 4px;">{{ $t('prodotti.label.prezzo_assegnato') }}: </span>
            <number-input v-model.number="form.price_costumer" :min="0" type="price" suffix="€" hide-buttons class="left"/>
        </v-flex>

        <v-flex xs12 sm6 class="mt-3">
            <span class="left" style="margin-top: 4px;">{{ $t('prodotti.label.quantita') }}: </span>
            <number-input v-model.number="form.quantita" :min="0" class="left"/>
        </v-flex>

        <v-flex xs12 sm6 class="mt-3">
            <span class="left" style="margin-top: 4px;">{{ $t('prodotti.label.quantita_esterna') }}: </span>
            <number-input v-model.number="form.quantita_esterna" :min="0" class="left"/>
        </v-flex>

        <categorie-prodotti-select :label="$t('magazzino.label.categorie_tutte')" v-model="categoria" solo-inverted flat class="input--dense" style="margin-top: 20px;"/>
  
      </form-dialog>
    </main>
  </template>
  
  <script>
  import Toggleable from '@/mixins/toggleable'
  import FormDialog from '@/components/base/FormDialog'
  import ProductsDataTable from '@/components/ProductsDataTable'
  import { CategorieProdottiSelect } from '@/components/inputs'
  import NumberInput from '@/components/inputs/NumberInput'
  
  export default {
      name: 'NewProductDialog',
      mixins: [Toggleable],
      components: { ProductsDataTable, FormDialog, CategorieProdottiSelect, NumberInput },
      props: {
          items: {
              type: Array,
              default: () => []
          }
      },
      data: () => ({
          sendingToMagazzino: false,
          categoria: '',
          form:{
            sku: '',
            produttore: '',
            name: '',
            permalink: 'permalink prodotto',
            description: 'Descrizione prodotto',
            price: 0,
            price_costumer: 0,
            src: 'src prodotto',
            quantita: 0,
            quantita_esterna: 0,
            category: []
          },
          arrayForm: []
      }),
      computed: {
      },
      methods: {
          show () {
              this.isActive = true
          },
          onConfirm () {
              this.sendingToMagazzino = true
              this.$api.magazzino.getCategories().then(response => {
                this.form.category.push(response.data.find(x => x.id == this.categoria))
                this.arrayForm.push(this.form);
                this.$api.magazzino.addToLocal(this.arrayForm).then(() => {
                    this.sendingToMagazzino = false
                    this.isActive = false
                    this.$snackbar.show(this.$t('magazzino.messaggi.prodotto_aggiunto'), 'success')
                    this.$emit('success')
                }).catch(e => {
                    this.$snackbar.showServerError(e)
                    this.sendingToMagazzino = false
                    this.$emit('error')
                })
            })
          }
      }
  }
  </script>
  